import { CircularProgress, CloudUploadIcon, FileUpload, Typography } from "@firecms/ui";

import { type ExplorerUploadDropzoneProps } from "./ExplorerUploadDropzone.types";

const ExplorerUploadDropzone: React.FC<ExplorerUploadDropzoneProps> = ({ uploading, disabled, onUploadFiles }) => {
  const isDisabled = disabled || uploading;

  return (
    <div className="relative">
      <FileUpload
        accept={{ "*/*": [] }}
        disabled={isDisabled}
        size="medium"
        title="Dateien hochladen"
        onFilesAdded={(files) => {
          void onUploadFiles(files);
        }}
        uploadDescription={
          <span className="inline-flex items-center gap-2 text-primary">
            <CloudUploadIcon />
            <span>Dateien hierher ziehen oder klicken zum Auswählen</span>
          </span>
        }
      />

      {uploading ? (
        <div className="absolute inset-0 flex items-center justify-center rounded-md bg-white/80 dark:bg-surface-950/80">
          <div className="flex items-center gap-2">
            <CircularProgress size="small" />
            <Typography variant="label">Wird hochgeladen…</Typography>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ExplorerUploadDropzone;
